// dashboard calls go through /internal so they stay out of the customer's api logs
const connectionHeader = (connectionId) => ({ 'x-trackstar-connection-id': connectionId });

export const replaceEmptyStringsWithNull = (object) => {
  Object.keys(object).forEach((key) => {
    if (typeof object[key] === 'object' && object[key] !== null) {
      replaceEmptyStringsWithNull(object[key]);
    } else if (object[key] === '') {
      // eslint-disable-next-line no-param-reassign
      object[key] = null;
    }
  });
};

export const formatDateForInput = (date) => {
  if (!date) return '';
  return date.slice(0, 16);
};

export const formatDateForApi = (date) => `${date}:00.000Z`;

export const getResources = (trackstar, connectionId, apiPath) => trackstar(`internal/${apiPath}`, 'GET', null, 'json', connectionHeader(connectionId))
  .then((data) => data.data || [])
  .catch((error) => {
    console.error('Error:', error);
    return [];
  });

const rejectWithDetail = (data) => {
  if (!data.error) return null;
  const message = data.detail
    ? `${data.error}\n${JSON.stringify(data.detail, null, 2)}`
    : data.error;
  return Promise.reject(message);
};

export const createResource = (trackstar, connectionId, apiPath, body) => {
  replaceEmptyStringsWithNull(body);
  return trackstar(`internal/${apiPath}`, 'POST', body, 'json', connectionHeader(connectionId))
    .then((data) => rejectWithDetail(data) ?? data.data);
};

export const updateResource = (trackstar, connectionId, apiPath, id, body) => {
  replaceEmptyStringsWithNull(body);
  return trackstar(`internal/${apiPath}/${id}`, 'PUT', body, 'json', connectionHeader(connectionId))
    .then((data) => rejectWithDetail(data) ?? data.data);
};

export const executeAction = (trackstar, connectionId, method, endpoint, body = null) => trackstar(`internal/${endpoint}`, method, body, 'json', connectionHeader(connectionId))
  .then((data) => {
    if (data.error) return Promise.reject(data.error);
    return data.data;
  });

export const generateSandbox = (trackstar, integrationType) => trackstar(`internal/sandbox/generate-sandbox/${integrationType}`, 'POST');

// resourceKey is 'orders' or 'products'; body is empty because the order/product is auto-generated
export const simulateCreateCartResource = (trackstar, connectionId, resourceKey) => createResource(trackstar, connectionId, `sandbox/simulate/cart/${resourceKey}`, {});

export const getSandboxWriteInfo = (trackstar, connectionId) => trackstar('internal/integrations/wms/sandbox/write-info', 'GET', null, 'json', connectionHeader(connectionId));
